import React from 'react'

import Skeleton from '@client/components/Skeleton'
import HorizontalLine from '@client/components/Sidebar/HorizontalLine'

const TabDesignLoading = () => {
  return (
    <div className="sidebar-content sidebar-content-design">
      <div className="row">
        <div className="col-12">
          <Skeleton width={150} />
        </div>
      </div>

      <div className="row mt1 mb2">
        <div className="col-6">
          <Skeleton width={140} height={30} />
        </div>
        <div className="col-6">
          <Skeleton width={140} height={30} />
        </div>
      </div>

      <HorizontalLine />

      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={50} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={40} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={325} height={30} />
        </div>
      </div>

      <div className="row mt1">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <div className="row mt1 mb2">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <HorizontalLine />

      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={50} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={40} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={325} height={30} />
        </div>
      </div>

      <div className="row mt1">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <div className="row mt1 mb2">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <HorizontalLine />

      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={50} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={40} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={325} height={30} />
        </div>
      </div>

      <div className="row mt1">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <HorizontalLine />

      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={50} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={40} />
        </div>
      </div>
      <div className="row mt1">
        <div className="col-12">
          <Skeleton width={325} height={30} />
        </div>
      </div>

      <div className="row mt1">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>

      <div className="row mt1 mb2">
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
        <div className="col-6">
          <Skeleton width={40} />
          <div className="mt1">
            <Skeleton width={140} height={30} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TabDesignLoading
